import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=bf4fd184&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=bf4fd184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4fd184",
  null
  
)

export default component.exports